<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="单位名称" prop="name" :class="checkNameChange('name', formData.name)? 'redItem' : ''">
          <div style="display: flex">
            <el-input v-model="formData.name" auto-complete="off" :disabled="true"></el-input>
            <el-button v-if="showUpdateDeptNameBtn&&!disabled" type="primary"
                       style="width:150px;margin-top: 1px;margin-left: 2px"
                       size="small"
                       @click="showDlgCA">变更单位名称
            </el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="机构类型" prop="type"
                      :class="checkNameChange('type', formData.type)? 'redItem' : null">
          <el-select v-model="formData.type" style="width: 100%" placeholder="请选择" :disabled="disabled">
            <el-option
              v-for="(item,index) in machanismType"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="统一社会信用代码" prop="tyshxydm"
                      :class="checkNameChange('tyshxydm', formData.tyshxydm)? 'redItem' : null">
          <el-input v-model="formData.tyshxydm" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="登记注册类型" prop="djzclx"
                      :class="checkNameChange('djzclx', formData.djzclx)? 'redItem' : null">
          <el-select v-model="formData.djzclx" style="width: 100%" placeholder="请选择" :disabled="disabled">
            <el-option
              v-for="(item,index) in djzclxList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="机构所在地" prop="areas"
                  :class="checkNameChange('areas', formData.areas)? 'redItem' : null">
      <el-cascader :disabled="disabled" style="width: 100%"
                   size="large"
                   :options="areaData"
                   v-model="formData.areas"
                   @change="areaChange">
      </el-cascader>
    </el-form-item>
    <el-form-item label="注册地址" prop="address"
                  :class="checkNameChange('address', formData.address)? 'redItem' : null">
      <el-input v-model="formData.address" maxlength="30" auto-complete="off" :disabled="disabled"></el-input>
    </el-form-item>
    <el-form-item label="办公地址" prop="workAddress"
                  :class="checkNameChange('workAddress', formData.workAddress)? 'redItem' : null">
      <el-input v-model="formData.workAddress" maxlength="100" auto-complete="off" :disabled="disabled"></el-input>
    </el-form-item>

    <el-row>
      <el-col :span="12">
        <el-form-item label="注册资本" prop="zczb"
                      :class="checkNameChange('zczb', formData.zczb)? 'redItem' : null">
          <el-input v-model="formData.zczb" maxlength="20" auto-complete="off"
                    :disabled="disabled">
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="成立日期" prop="establishDate" style="text-align: left"
                      :class="checkNameChange('establishDate', formData.establishDate)? 'redItem' : null">
          <el-date-picker :disabled="disabled"
                          v-model="formData.establishDate"
                          type="date"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="主营业务" prop="zyyw"
                  :class="checkNameChange('zyyw', formData.zyyw)? 'redItem' : null">
      <el-input type="text" v-model="formData.zyyw" maxlength="50" auto-complete="off"
                :disabled="disabled"></el-input>
    </el-form-item>
    <el-form-item label="资质" prop="qualification"
                  :class="checkNameChange('qualification', formData.qualification)? 'redItem' : null">
      <el-input type="text" v-model="formData.qualification" maxlength="80" auto-complete="off"
                :disabled="disabled"></el-input>
    </el-form-item>
    <el-form-item label="人员" prop="personnel"
                  :class="checkNameChange('personnel', formData.personnel)? 'redItem' : null">
      <el-input type="text" v-model="formData.personnel" maxlength="50" auto-complete="off"
                :disabled="disabled"></el-input>
    </el-form-item>
    <el-form-item label="注册专业" prop="regiestMajor"
                  :class="checkNameChange('regiestMajor', formData.regiestMajor)? 'redItem' : null">
      <el-select v-model="formData.regiestMajor" :disabled="majorDisabled" style="width: 100%" @change="changeFileType">
        <el-option v-for="item in getRegiestMajor('one')"
                   :value="item.value"
                   :label="item.name"
                   :key="item.value"
                   :disabled="item.disabled"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="其他专业" prop="regiestMajorTwo"
                  :class="checkNameChange('regiestMajorTwo', formData.regiestMajorTwo)? 'redItem' : null">
      <el-select v-model="formData.regiestMajorTwo" :disabled="majorDisabled" style="width: 100%" :clearable="true">
        <el-option v-for="item in getRegiestMajor('two')"
                   :value="item.value"
                   :label="item.name"
                   :key="item.value"
                   :disabled="item.disabled"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="单位文件" prop="dwjj">
      <upload-manual ref="uploadManual" :disabled="disabled"
                     :action="isModify?global.baseUrl + '/mAttachUpdateRecord/uploadFile':global.baseUrl + '/mAttach/uploadFile'"
                     :onRemove="removeFile" :autoUpload="true" @onSuccess="uploadFileSuccess" :onPreview="previewFile"
                     :onDownload="downloadFile" :fileConfig="fileConfig" :file-list="formData.files"></upload-manual>
    </el-form-item>
    <el-form-item class="remark">
      <span>{{ fileTip }}</span>
    </el-form-item>


    <el-row>
      <el-col :span="12">
        <el-form-item label="邮政编码" prop="zipcode"
                      :class="checkNameChange('zipcode', formData.zipcode)? 'redItem' : null">
          <el-input v-model="formData.zipcode" maxlength="25" :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="主管单位" prop="zgdw"
                      :class="checkNameChange('zgdw', formData.zgdw)? 'redItem' : null">
          <el-input v-model="formData.zgdw" auto-complete="off" maxlength="25" :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
    </el-row>


    <el-row>
      <el-col :span="12">
        <el-form-item label="传真" prop="fax"
                      :class="checkNameChange('fax', formData.fax)? 'redItem' : null">
          <el-input v-model="formData.fax" auto-complete="off" maxlength="20" :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="邮箱" prop="email"
                      :class="checkNameChange('email', formData.email)? 'redItem' : null">
          <el-input v-model="formData.email" auto-complete="off" maxlength="30" :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="基本账户开户行" prop="jbzhkhh"
                      :class="checkNameChange('jbzhkhh', formData.jbzhkhh)? 'redItem' : null">
          <el-select v-model="formData.jbzhkhh" placeholder="请选择" style="width: 100%" :disabled="disabled">
            <el-option
              v-for="(item,index) in bankList"
              :key="index"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="单位网址" prop="url"
                      :class="checkNameChange('url', formData.url)? 'redItem' : null">
          <el-input v-model="formData.url" auto-complete="off" maxlength="45" :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="基本账户开户名" prop="jbzhkhm"
                      :class="checkNameChange('jbzhkhm', formData.jbzhkhm)? 'redItem' : null">
          <el-input v-model="formData.jbzhkhm" auto-complete="off" maxlength="25" :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="基本账户开户账号" prop="jbzhkhzh"
                      :class="checkNameChange('jbzhkhzh', formData.jbzhkhzh)? 'redItem' : null">
          <el-input v-model="formData.jbzhkhzh" auto-complete="off" maxlength="25" :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="党组织建制" prop="dzzjz" style="text-align: left">
          <el-radio-group v-model="formData.isDzzjz">
            <el-radio :label="false" :disabled="disabled">无</el-radio>
            <el-radio :label="true" :disabled="disabled">有</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-show="formData.isDzzjz">
        <el-form-item label="党组织形式" prop="dzzxs"
                      :class="checkNameChange('dzzxs', formData.dzzxs)? 'redItem' : null">
          <el-select v-model="formData.dzzxs" style="width: 100%" placeholder="请选择" :disabled="disabled">
            <el-option
              v-for="(item,index) in dzzxs"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="专业" prop="major"
                      :class="checkNameChange('major', formData.major)? 'redItem' : null">
          <el-select v-model="formData.major" :disabled="true" style="width: 100%;">
            <el-option v-for="item in majorEntities" :label="item.name" :value="item.value"
                       :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="协会职务" prop="associationDuties"
                      :class="checkNameChange('associationDuties', formData.associationDuties)? 'redItem' : null">
          <el-select v-model="formData.associationDuties" :disabled="true" style="width: 100%">
            <el-option v-for="item in associationDutiesEntities" :label="item.name" :value="item.value"
                       :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="其他专业" prop="majorTwo"
                      :class="checkNameChange('majorTwo', formData.majorTwo)? 'redItem' : null">
          <el-select v-model="formData.majorTwo" :disabled="true" style="width: 100%;" :clearable="true">
            <el-option v-for="item in majorEntities" :label="item.name" :value="item.value"
                       :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="formData.isDzzjz">
      <el-col :span="12">
        <el-form-item label="固定党员人数" prop="dygdrs"
                      :class="checkNameChange('dygdrs', formData.dygdrs)? 'redItem' : null">
          <el-input-number :disabled="disabled" v-model="formData.dygdrs" :min="0" :max="99999"
                           label="固定党员人数"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="流动党员人数" prop="dyldrs"
                      :class="checkNameChange('dyldrs', formData.dyldrs)? 'redItem' : null">
          <el-input-number :disabled="disabled" v-model="formData.dyldrs" :min="0" :max="99999"
                           label="流动党员人数"></el-input-number>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="formData.isDzzjz">
      <el-col :span="12">
        <el-form-item label="书记姓名" prop="secretaryPersonName"
                      :class="checkNameChange('secretaryPersonName', formData.secretaryPersonName)? 'redItem' : null">
          <el-input v-model="formData.secretaryPersonName" auto-complete="off" maxlength="25"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="书记联系电话" prop="secretaryPersonOfficeTel"
                      :class="checkNameChange('secretaryPersonOfficeTel', formData.secretaryPersonOfficeTel)? 'redItem' : null">
          <el-input v-model="formData.secretaryPersonOfficeTel" auto-complete="off" maxlength="25"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="formData.isDzzjz">
      <el-col :span="12">
        <el-form-item label="副书记姓名" prop="deputySecretaryPersonName"
                      :class="checkNameChange('deputySecretaryPersonName', formData.deputySecretaryPersonName)? 'redItem' : null">
          <el-input v-model="formData.deputySecretaryPersonName" auto-complete="off" maxlength="25"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="副书记联系电话" prop="deputySecretaryPersonOfficeTel"
                      :class="checkNameChange('deputySecretaryPersonOfficeTel', formData.deputySecretaryPersonOfficeTel)? 'redItem' : null">
          <el-input v-model="formData.deputySecretaryPersonOfficeTel" auto-complete="off" maxlength="25"
                    :disabled="disabled"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <dlg-c-a ref="dlgCARef" :form-data="formData"></dlg-c-a>
    <approve-log v-if="showLog!=false" :form-data="formData" :form-id="type===3?formData.deptRemoveApplyId:formData.deptId"
                 :type="type"></approve-log>
  </div>
</template>

<script>
import KtUploadFiles from '@/views/Core/KtUploadFiles';
import {CodeToText, regionData} from 'element-china-area-data';
import UploadManual from '../Core/UploadManual';
import {
  buildEntitesIndexX,
  getAssociationDutiesEntities,
  getMajorEntities,
  getRegiestMajorEntities,
} from '../../utils/entities';
import DlgCA from './DlgCA';
import global from '../../utils/global';
import ApproveLog from './ApproveLog';

export default {
  name: 'BaseInfo',
  components: {ApproveLog, DlgCA, UploadManual, KtUploadFiles},
  props: ['formData', 'disabled', 'majorDisabled', 'isModify', 'fileConfig', 'showUpdateDeptNameBtn', 'sourceModel', 'type','showLog'],

  data() {
    this.$api.dictionary.getDictionaryByCondition('基本账户开户行').then((res) => {
      if (res.code === 200) {
        this.bankList = res.data;
      }
    });
    this.$api.dictionary.getDictionaryByCondition('登记注册类型').then((res) => {
      if (res.code === 200) {
        this.djzclxList = res.data;
      }
    });
    let groupTitle = '机构类型';
    if (this.sourceModel === 'register') { //是注册页面
      groupTitle = '机构类型(注册)';
    }
    this.$api.dictionary.getDictionaryByCondition(groupTitle).then((res) => {
      if (res.code === 200) {
        this.machanismType = res.data;
      }
    });
    let regiestMajor = getRegiestMajorEntities();
    buildEntitesIndexX(regiestMajor, 'value');
    let aAssociationDutiesEntities = getAssociationDutiesEntities();
    let aMajorEntities = getMajorEntities();

    return {
      uploadTip: '<span style=\'color: red\'>需要上传企业营业执照、资质证书、宣传资料以及其他资料并加盖公章扫描件。</span>',
      machanismType: [],
      djzclxList: [],
      bankList: [],
      areaData: regionData,
      regiestMajor: regiestMajor,
      fileTip: null,
      selectValue: this.formData.regiestMajor,
      associationDutiesEntities: aAssociationDutiesEntities.Rows,
      majorEntities: aMajorEntities.Rows,

      dzzxs: [
        {
          name: '党支部',
          value: 1,
        }, {
          name: '党总支',
          value: 2,
        }, {
          name: '党委',
          value: 3,
        },{
          name: '联合党支部',
          value: 4,
        }],
      baseUrl: global.baseUrl,
    };
  },
  methods: {
    initUploadFile() {
      this.$refs.uploadManual.initUploadFile()
    },
    checkNameChange(fieldName, value) {
      let flag = false;
      if (this.formData.oldContent) {
        for (let key in this.formData.oldContent) {
          if (fieldName === 'areas' && key === 'areas') { // 机构所在地 数组对比
            const newData = this.formData.areas.join(',');
            const oldData = this.formData.oldContent.areas.join(',');
            if (newData != oldData) {
              flag = true;
              break;
            }
          } else if (key == fieldName && value != this.formData.oldContent[key]) {
            flag = true;
            break; // break跳出循环
          }
        }
      }
      return flag;
    },
    areaChange: function(areas) {//选择机构所在地后执行的方法
      var sProvinceCode = areas[0];
      var sCityCode = areas[1];
      var sAreaCode = areas[2];
      this.formData.provinceCode = sProvinceCode;
      this.formData.provinceName = CodeToText[sProvinceCode];
      this.formData.cityCode = sCityCode;
      this.formData.cityName = CodeToText[sCityCode];
      this.formData.areaCode = sAreaCode;
      this.formData.areaName = CodeToText[sAreaCode];
    },
    previewFile(file) {
      var savePath = null;
      if (file.savePath) {
        savePath = file.savePath;
      } else if (file.url) {
        savePath = file.url;
      } else {
        savePath = file.response.data.savePath;
      }
      const secondDir = this.baseUrl;
      const src = secondDir + '/' + savePath;
      window.open('./static/pdf/web/viewer.html?file=' + encodeURIComponent(src));
    },
    /**
     * 下载附件
     */
    downloadFile: function(file) {
      var sFileId = file.id || file.attachId;
      var sFileName = file.saveName || file.fileName;
      if (this.isModify) {
        this.$api.attachUpdateRecord.download({attachId: sFileId, name: sFileName});
      } else {
        this.$api.attach.download({attachId: sFileId, name: sFileName});
      }
    },
    /**
     * 删除附件
     */
    removeFile: function(data, fileList) {
      let oParams = {
        ids: data.id,
      };
      if (this.isModify) {//是修改后的数据
        this.$api.attachUpdateRecord.batchDelete(oParams).then(res => {
          if (res.code === 500) {
            this.$message({message: res.msg, type: 'error'});
          } else {
            this.$message({message: '删除文件成功', type: 'success'});
            this.formData.files = fileList;
          }
        });
      } else {
        this.$api.attach.batchDelete(oParams).then(res => {
          if (res.code === 500) {
            this.$message({message: res.msg, type: 'error'});
          } else {
            this.$message({message: '删除文件成功', type: 'success'});
            this.formData.files = fileList;
          }
        });
      }
    },
    /**
     * 上传文件成功
     */
    uploadFileSuccess: function(response, file, fileList) {
      this.formData.files = fileList;
    },
    changeFileType: function(array) {
      let fileType = this.regiestMajor[array].fileType.toString();
      if (array === '1') {
        this.fileTip = '上传资料备注：修缮工程施工单位：单位简介、营业执照、资质证明';
      }
      if (array === '2') {
        this.fileTip = '上传资料备注：电梯单位：单位简介、营业执照、特种设备许可制（安全、安装、维修）';
      }
      if (array === '3') {
        this.fileTip = '上传资料备注：监理单位：营业执照、资质证明、单位简介';
      }
      if (array === '4') {
        this.fileTip = '上传资料备注：材料单位：单位简介、营业执照、生产许可证、材料备案证';
      }
      if (array === '5') {
        this.fileTip = '上传资料备注：设计单位：单位简介、营业执照、资质证明';
      }
      this.$emit('changeFileType', fileType);

    },

    getFileTip(array) {
      if (array == null) {
        this.fileTip = null;
      }
      if (array === '1') {
        this.fileTip = '上传资料备注：修缮工程施工单位：单位简介、营业执照、资质证明';
      }
      if (array === '2') {
        this.fileTip = '上传资料备注：电梯单位：单位简介、营业执照、特种设备许可制（安全、安装、维修）';
      }
      if (array === '3') {
        this.fileTip = '上传资料备注：监理单位：营业执照、资质证明、单位简介';
      }
      if (array === '4') {
        this.fileTip = '上传资料备注：材料单位：单位简介、营业执照、生产许可证、材料备案证';
      }
      if (array === '5') {
        this.fileTip = '上传资料备注：设计单位：单位简介、营业执照、资质证明';
      }
    },
    changeDzzjz(param) {
      if (!param) {
        this.initDzzjzInfo();
      }

    },
    /**
     * 初始化党组织信息
     */
    initDzzjzInfo() {
      this.formData.dzzxs = null;
      this.formData.dygdrs = null;
      this.formData.dyldrs = null;
      this.formData.secretaryPersonName = null;
      this.formData.secretaryPersonOfficeTel = null;
      this.formData.deputySecretaryPersonName = null;
      this.formData.deputySecretaryPersonOfficeTel = null;
    },
    showDlgCA() {
      this.$refs.dlgCARef.visible = true;
      this.$refs.dlgCARef.caInfo.caCode = '';
    },
    /**
     * 注册专业列表
     */
    getRegiestMajor(type) {
      if(type === 'one'){
        if(this.formData.regiestMajorTwo){
          for(let i=0;i<this.regiestMajor.Rows.length;i++){
            if( this.regiestMajor.Rows[i].value == this.formData.regiestMajorTwo){
              this.regiestMajor.Rows[i].disabled =true
            }else{
              this.regiestMajor.Rows[i].disabled =false
            }
          }
        }
      }else if(type === 'two'){
        if(this.formData.regiestMajor){
          for(let i=0;i<this.regiestMajor.Rows.length;i++){
            if(this.regiestMajor.Rows[i].value == this.formData.regiestMajor){
              this.regiestMajor.Rows[i].disabled =true
            }else{
              this.regiestMajor.Rows[i].disabled =false
            }
          }
        }
      }
      return  this.regiestMajor.Rows
    }
  },
  mounted() {
  },
};
</script>

<style scoped lang="less">
.grid-content {
  min-height: 36px;
}

.redItem /deep/ .el-form-item__label {
  color: red !important;
}

.redItem /deep/ .el-input__inner {
  color: red !important;
}

.remark span {
  color: red;
  margin-right: 5px;
}

</style>



// WEBPACK FOOTER //
// src/views/Member/BaseInfo.vue